import {useSelector} from 'react-redux';

const selectScheduleTags = (state, eventId) => state.events[eventId].schedule.categories;

/**
 * Selects the schedule tags for a given event ID
 * @param {number} eventId
 * @returns {array} Array of schedule tags
 */
export function useScheduleTags(eventId) {
    return useSelector(state => selectScheduleTags(state, eventId));
}
